import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Home from "./pages/Home";
import BooksPage from "./pages/Bookpage";
import ProductPage from "./pages/Productpage";
import NavBar from "./components/Navbar";
import Footer from "./components/Footer";
import AboutUs from "./pages/Aboutus";
import Login from "./pages/Login";
import ProfileSetup from "./pages/Profilesetup";
import Profile from "./pages/Profile";
import Register from "./pages/Register";
import SearchResults from "./pages/SearchResults";
import CheckoutPage from "./pages/CheckoutPage";
import OrderSuccess from "./pages/OrderSuccess";
import OrderFailed from "./pages/OrderFailed";
import Admin from "./pages/Admin";
import { CartProvider } from "./pages/CartContext";
import CareerForm from "./pages/Career";
import Blogs from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Courses from "./pages/Courses";
import Sessions from "./pages/Sessions";
import MotherhoodApp from "./pages/MotherhoodApp";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />

      {/* ✅ Wrap everything inside CartProvider */}
      <CartProvider>
        <Router>
          <ScrollToTop />
          <NavBar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/books" element={<BooksPage />} />
            <Route path="/books/:id" element={<ProductPage />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/profile-setup" element={<ProfileSetup />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/search" element={<SearchResults />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/order-success" element={<OrderSuccess />} />
            <Route path="/order-failed" element={<OrderFailed />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/career" element={<CareerForm />} />
             <Route path="/blog" element={<Blogs />} />
             <Route path="/blog/:slug" element={<BlogPost />} />
             <Route path="/resources/courses" element={<Courses />} />
             <Route path="/resources/sessions" element={<Sessions />} />
             <Route path="/resources/motherhood-app" element={<MotherhoodApp />} />
          </Routes>
          <Footer />
        </Router>
      </CartProvider>
    </>
  );
}

export default App;
